// extracted by mini-css-extract-plugin
export default {"operations":"style_operations__kJJif"};